module.exports = __webpack_public_path__ + "img/animal_avatar-07.74f0a92d.png";